import cssVariables from 'tfs.css-variables'

export default {
  wrapper: {
    position: 'relative',
  },
  select: {
    fontFamily: cssVariables.fontFamily,
    color: cssVariables.colorGrayB,
    fontSize: '1em',
    width: '100%',
    height: '2.5rem',
    padding: '0 0.5rem',
    paddingRight: '2rem',
    border: `1px solid ${cssVariables.colorWhiteBorder}`,
    borderRadius: '0.5rem',
    backgroundColor: 'transparent',
    boxShadow: `inset 0px -0.1rem 0 0 ${cssVariables.colorWhiteBorder}`,
    position: 'relative',
    zIndex: 1,
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',

    '&:focus': {
      borderColor: cssVariables.colorBlue,
      boxShadow: `inset 0px -0.1rem 0 0 ${cssVariables.colorBlue}`,
      outline: 'none',
    },
  },
  plain: {
    border: 'none',
    boxShadow: 'none',
  },
  disabled: {
    backgroundColor: `${cssVariables.colorGrayF}`,
  },
  icon: {
    color: cssVariables.colorGrayB,
    fontSize: '1.1em',
    position: 'absolute',
    right: '0.5rem',
    top: 0,
    zIndex: 0,
    transform: 'translateY(50%)',
    cursor: 'text',
  },
  hasValue: {
    color: cssVariables.colorGrayB,
  },
  isInvalidInput: {
    '&[type=date]': {
      color: cssVariables.colorErrorBackground,
    },
    '&::placeholder': {
      color: cssVariables.colorErrorBackground,
    },
  },
  isInvalidIcon: {
    transform: 'rotate(-360deg)',
    transition: 'all 0.8s',
    color: cssVariables.colorErrorBackground,
  },
  isEditedInput: {
    borderColor: cssVariables.colorGreen,
    boxShadow: `inset 0px -0.1rem 0 0 ${cssVariables.colorGreen}`,
    outline: 'none',
  },
}
